import { render, staticRenderFns } from "./LegalInfoStep.vue?vue&type=template&id=85a8d9ea"
import script from "./LegalInfoStep.vue?vue&type=script&lang=js"
export * from "./LegalInfoStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports